import React, {Component} from 'react';
import PropTypes from 'prop-types';
//import TestData from './data'
import TableFilter from '../TableFilter'
import RubricaTable from './RubricaTable'
import RubricaDocumentCreator from './RubricaDocumentCreator'
import RubricaTipoSoggettoSelect from './RubricaTipoSoggettoSelect'
import RubricaScrollable from './RubricaScrollable'
import RubricaReportList from './RubricaReportList'
import ErrorMessage from '../ErrorMessage'
import RubricaListTypeButton from './RubricaListTypeButton'
import {client} from '../../Client';
import FileSaver from 'file-saver';
import FiltriMultiDropdown from '../FiltriMultiDropdown'
import QueryFilterRubrica from './QueryFilterRubrica'
import {createInstance} from '../../Helpers';
import RubricaElencoCompleto from "../../pdf/RubricaElencoCompleto";
import RubricaElencoCompatto from "../../pdf/RubricaElencoCompatto";

class RubricaList extends Component {
    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();
        this.storeInstance = createInstance();
        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeFilterSoggetto = this.onChangeFilterSoggetto.bind(this)
        this.onChangeFilterTelefono = this.onChangeFilterTelefono.bind(this)
        this.onChangeFilterEmail = this.onChangeFilterEmail.bind(this)
        this.onChangeFilterDipartimento = this.onChangeFilterDipartimento.bind(this)
        this.onChangeFilterOrganizzazione = this.onChangeFilterOrganizzazione.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.onAddSoggetto = this.onAddSoggetto.bind(this)
        this.onRemoveSender = this.onRemoveSender.bind(this)
        this.onChangeTipoSender = this.onChangeTipoSender.bind(this)
        this.onChangeLetter = this.onChangeLetter.bind(this)
        this.onChangeTipoSoggetto = this.onChangeTipoSoggetto.bind(this)
        this.onExportClick = this.onExportClick.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.loadData = this.loadData.bind(this)
        this.onChangeQueryFilter = this.onChangeQueryFilter.bind(this)
        this.onChangeMultiFiltri = this.onChangeMultiFiltri.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)

        this.pdfExport = this.pdfExport.bind(this);
    }

    getDefaultState(){
        return {
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: 'soggetto',
                direction: 'A',
                data: [{field: 's.cognome', direction: 'A'}, {field: 's.nome', direction: 'A'}]},
            filterInfo: {
                conditions: '',
                multiFilter: [],
            },
            _loading: false,
            error: null,
            senderList:[],
            cfg: client.getConfigurazione(),
            filterLetter: {tipo:'s', lettera:'All'},
            filterTipo: {isProspect:false, isCliente:false, isFornitore:false, isTp:false},
            listViewType: 'l',
            showItem: null,
        };
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.soggetto !== undefined && this.state.filterInfo.soggetto !== ''){
            msg += 'KW Soggetto: ' + this.state.filterInfo.soggetto + ' ';
        }
        if (this.state.filterInfo.dipartimento !== undefined && this.state.filterInfo.dipartimento !== ''){
            msg += 'KW Dipartimento: ' + this.state.filterInfo.dipartimento + ' ';
        }
        if (this.state.filterInfo.organizzazione !== undefined && this.state.filterInfo.organizzazione !== ''){
            msg += 'KW Organizzazione: ' + this.state.filterInfo.organizzazione + ' ';
        }
        if (this.state.filterInfo.telefono !== undefined && this.state.filterInfo.telefono !== ''){
            msg += 'Telefono: ' + this.state.filterInfo.telefono + ' ';
        }
        if (this.state.filterInfo.email !== undefined && this.state.filterInfo.email !== ''){
            msg += 'Email: ' + this.state.filterInfo.email + ' ';
        }
        if (this.state.filterTipo.isProspect){
            msg += ' Prospect: SI';
        }
        if (this.state.filterTipo.isCliente){
            msg += ' Clienti: SI';
        }
        if (this.state.filterTipo.isFornitore){
            msg += ' Fornitore: SI';
        }
        if (this.state.filterTipo.isTp){
            msg += ' Terze parti: SI';
        }
        let condAggiuntive = client.getCondizioniAggiuntive(this.state.filterInfo.conditions, this.state.filterInfo.multiFilter)
        if (condAggiuntive){
            msg += ' ' + condAggiuntive;
        }
        return  msg.trim();
    }


    onAddSoggetto(evt, soggetto) {
        let senders = this.state.senderList;
        senders.push({soggetto, tipo: 'S'});
        this.setState({senderList: senders});
    }

    onRemoveSender(soggetto){
        let senders=[]
        if (soggetto !== undefined)
        {
            senders = this.state.senderList.filter((it)=>(it.soggetto.idSoggetto !== soggetto.idSoggetto))
        }
        this.setState({senderList: senders})
    }

    toggleTipoSender(tipo){
        return tipo === 'S' ? 'C' : 'S';
    }

    onChangeTipoSender(sender){
        let senders = this.state.senderList.map((it)=>{
            if (it.soggetto.idSoggetto !== sender.soggetto.idSoggetto){
                return it;
            }
            else
            {
                return ({soggetto: it.soggetto, tipo: this.toggleTipoSender(it.tipo)});
            }
        })
        this.setState({senderList: senders});
    }

    componentWillMount() {
    }

    componentWillUnmount() {
        if (this.storeInstance) {
            this.storeInstance.save('rubricalist', this.state);
        }
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('rubricalist', this , () => {

                if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
                {
                    if (this.props.location.state.from.pathname.includes("rubrica/edit"))
                    {
                        let soggetto = this.props.location.state.item.soggetto;
                        soggetto.idDipartimento = this.props.location.state.item.dipartimento
                        soggetto.idDipartimento.idOrganizzazione = this.props.location.state.item.organizzazione
                        let items = this.state.items.map((cit) => {
                            if (cit.idSoggetto === soggetto.idSoggetto)
                            {
                                return soggetto;
                            }
                            return cit;
                        });
                        this.setState({items: items, showItem: soggetto});
                    }
                    else if (this.props.location.state.from.pathname.includes("rubrica/new"))
                    {
                        let soggetto = this.props.location.state.item.soggetto;
                        soggetto.idDipartimento = this.props.location.state.item.dipartimento
                        soggetto.idDipartimento.idOrganizzazione = this.props.location.state.item.organizzazione
                        let items = [soggetto];
                        this.setState({items: items.concat(this.state.items), showItem: soggetto});
                    }

                }
                else {
                    this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter);
                }
            }) === null){
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter);
        }
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter);}
        );
    }

    onChangePage(newpage) {

        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        }
        this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo, this.state.filterLetter)
    }

    onChangeFilter(data){
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, data, this.state.filterLetter)
    }
    onChangeFilterSoggetto(data){
        let fi = this.state.filterInfo;
        fi.soggetto = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi, this.state.filterLetter)
    }
    onChangeFilterDipartimento(data){
        let fi = this.state.filterInfo;
        fi.dipartimento = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi, this.state.filterLetter)
    }
    onChangeFilterOrganizzazione(data){
        let fi = this.state.filterInfo;
        fi.organizzazione = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi, this.state.filterLetter)
    }

    onChangeTipoSoggetto(isProspect, isCliente, isFornitore, isTp){
        let newFilterInfo = {
            isProspect,
            isCliente,
            isFornitore,
            isTp
        };
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, this.state.filterInfo, this.state.filterLetter, newFilterInfo);
    }

    onChangeFilterTelefono(data){
        let fi = this.state.filterInfo;
        fi.telefono = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi, this.state.filterLetter)
    }

    onChangeFilterEmail(data){
        let fi = this.state.filterInfo;
        fi.email = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, fi, this.state.filterLetter)
    }

    onChangeLetter(tipo, letter){
        let newOrderInfo = {
            field: tipo === 's' ? 's.cognome' : tipo+".nome",
            direction: 'A'
        };
        let newFilterLetter = {
            tipo:tipo,
            lettera:letter
        };
        this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo, newFilterLetter);
    }

    loadData(page, orderInfo, filterInfo, filterLetter, filterTipo = null) {
        if (filterTipo === null){
            filterTipo = this.state.filterTipo;
        }
        this.setState({_loading: true});
        client.loadRubricaList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo,
            filterLetter,
            filterTipo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        filterLetter: filterLetter,
                        filterTipo: filterTipo,
                        _loading: false,
                        error: null,
                        showItem: null,
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    pdfExport(tipo){
        this.loadCompleteData(tipo, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter, this.state.filterTipo);
    }

    loadCompleteData(tipoPdf, orderInfo, filterInfo, filterLetter, filterTipo) {
        this.setState({_loading: true});
        client.loadRubricaList(
            this.rowperpage,
            -1,
            orderInfo.data,
            filterInfo,
            filterLetter,
            filterTipo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        _loading: false,
                        error: null,
                    }, () =>{
                        let ce = null;
                        if (tipoPdf === "completo"){
                            ce = new RubricaElencoCompleto();
                            ce.setTitle("Elenco Soggetti - completo");
                            ce.setFileName("report-soggetti-completo.pdf");
                        }
                        else {
                            ce = new RubricaElencoCompatto();
                            ce.setTitle("Elenco Soggetti - compatto");
                            ce.setFileName("report-soggetti-compatto.pdf");
                        }
                        ce.setFilterDescription(this.getFilterDescription());
                        ce.createPdf(data.items);
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }
    onExportClick(tipo){

        this.setState({_loading: true});
        client.exportRubricaList(
            this.state.orderInfo.data,
            this.state.filterInfo,
            this.state.filterLetter,
            this.state.filterTipo,
            tipo
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'rubrica.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onDeleteClick(ev, soggetto){
        this.setState({_loading: true});
        client.deleteRubrica(soggetto).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter)
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });

    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    cambiaTipoLista(tipo){
        this.setState({listViewType: tipo}, () => {
            if (tipo === 'r'){
                //Ricarico senza paginazione
                this.loadData(-1, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter);
            } else if (this.state.page === -1){
                // Vengo dalla visualzizzazione report, reimposto la pagina a 1
                this.loadData(1, this.state.orderInfo, this.state.filterInfo, this.state.filterLetter);
            }
        });
    }

    onChangeQueryFilter(sql){
        let filter = this.state.filterInfo;
        filter.conditions = sql;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter, this.state.filterLetter)
    }

    onChangeMultiFiltri(ev, {name, value}){
        let filter = this.state.filterInfo;
        filter.multiFilter = value;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, filter, this.state.filterLetter)
    }

    onLoadingMultiFiltri(){}

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui huge loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Soggetti soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">
                            <RubricaListTypeButton
                                listType={this.state.listViewType}
                                onButtonClick={(t) => {this.cambiaTipoLista(t)}}
                            />
                        </div>
                    </div>
                </div>
            </h3>
            <div className="ui attached segment">

                <div className="ui four column stackable grid">
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.soggetto}
                            placeholder="Nome e cognome del soggetto..."
                            onChangeFilter={this.onChangeFilterSoggetto} />
                    </div>
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.dipartimento}
                            placeholder="Nome del dipartimento..."
                            onChangeFilter={this.onChangeFilterDipartimento} />
                    </div>
                    <div className="column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.organizzazione}
                            placeholder="Nome dell'organizzazione..."
                            onChangeFilter={this.onChangeFilterOrganizzazione} />
                    </div>
                    <div className="column">
                        <RubricaTipoSoggettoSelect
                            isProspect={this.state.filterTipo.isProspect}
                            isCliente={this.state.filterTipo.isCliente}
                            isFornitore={this.state.filterTipo.isFornitore}
                            isTp={this.state.filterTipo.isTp}
                            onChange={this.onChangeTipoSoggetto}
                        />
                    </div>
                    <div className="four wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.telefono}
                            placeholder="Numero di telefono..."
                            onChangeFilter={this.onChangeFilterTelefono} />
                    </div>
                    <div className="four wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.email}
                            placeholder="Email..."
                            onChangeFilter={this.onChangeFilterEmail} />
                    </div>
                    <div className="eight wide column">
                        <FiltriMultiDropdown tipo="RUB" name='filtri'
                                             value={this.state.filterInfo.multiFilter}
                                             onChange={this.onChangeMultiFiltri}
                                             onLoading={this.onLoadingMultiFiltri}
                        />
                    </div>
                    <div className="sixteen wide column">
                        <QueryFilterRubrica
                            tipo="QRYR1"
                            showPopup={true}
                            popupPosition="left center"
                            value={this.state.filterInfo.conditions}
                            placeholder="Inserisci qui una condizione SQL-like..."
                            onChangeFilter={this.onChangeQueryFilter}
                        ></QueryFilterRubrica>
                    </div>
                </div>

            {/*<RubricaLetterSelect*/}
                {/*letter={this.state.filterLetter.lettera}*/}
                {/*tipo={this.state.filterLetter.tipo}*/}
                {/*onChange={this.onChangeLetter}*/}
            {/*/>*/}
            </div>

            {
                this.state.listViewType === 'l' ? (

                    <RubricaTable
                        items={this.state.items}
                        senderList={this.state.senderList}
                        count={this.state.total}
                        page={this.state.page}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        filterDescription={this.getFilterDescription()}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onAddSoggetto={this.onAddSoggetto}
                        onExportRubrica={this.onExportClick}
                        onExportRubricaPdf={this.pdfExport}
                        onDeleteItem={this.onDeleteClick}
                        readOnly={client.getCurrentUser().isrolerubricaw===false}
                    />)

                    :

                    this.state.listViewType === 's' ? (

                    <RubricaScrollable
                        items={this.state.items}
                        senderList={this.state.senderList}
                        count={this.state.total}
                        page={this.state.page}
                        rowperpage={this.rowperpage}
                        tableOrderingField={this.state.orderInfo.columnName}
                        tableOrderingDirection={this.state.orderInfo.direction}
                        onChangePage={this.onChangePage}
                        onChangeOrder={this.onChangeColumnOrder}
                        onAddSoggetto={this.onAddSoggetto}
                        onExportRubrica={this.onExportClick}
                        onDeleteItem={this.onDeleteClick}
                        showItem={this.state.showItem}
                        readOnly={client.getCurrentUser().isrolerubricaw===false}
                    />)
                        :

                        <RubricaReportList
                            items={this.state.items}
                            filterDescription={this.getFilterDescription()}
                        />

            }
            <RubricaDocumentCreator
                senderList={this.state.senderList}
                idDivisione={this.state.cfg.idDivisione}
                onRemoveSender={this.onRemoveSender}
                onChangeTipoSender={this.onChangeTipoSender}
            />
            {loader}
        </div>)
    }
}

RubricaList.contextTypes = {
    router: PropTypes.object,
}


export default RubricaList;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaList.js
 **/